import { useStaticQuery, graphql } from "gatsby"

const useAgentsQuery = () => {
  return useStaticQuery(graphql`
    query AgentsQuery {
      allWpTeam(
        filter: {acf: {hideInDirectory: {ne: true}}}
        sort: {title: ASC}
      ) {
        nodes {
          ...AgentCard
        }
      }
    }
  `)
}

export default useAgentsQuery